import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateTime } from 'luxon';
import { GeneralService } from 'src/app/services/general/general.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';

@Component({
  selector: 'app-payment-dialog',
  templateUrl: './payment-dialog.component.html',
  styleUrls: ['./payment-dialog.component.scss'],
})
export class PaymentDialogComponent implements OnInit {
  public form: FormGroup;
  @Input() title: string = '';

  constructor(
    public dialogRef: MatDialogRef<PaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public general: GeneralService,
    private formBuilder: FormBuilder
  ) {
    this.form = this.formBuilder.group(
      {
        hours: [1, [Validators.required]],
        paymentMethod: ['paypal', [Validators.required]],
      },
      { validators: this.validateHours() }
    );
  }

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close();
  }

  get hoursInvalid() {
    return this.form.get('hours')?.invalid && this.form.get('hours')?.touched;
  }

  validateHours() {
    return (formGroup: FormGroup) => {
      let res = null;

      // return if another validator has already found an error on the matchingControl
      if (formGroup.errors && !formGroup.errors.badOrder) {
        return;
      }

      const controlHours = formGroup.controls['hours'];

      if (!(Number.isInteger(controlHours.value) && controlHours.value > 0)) {
        res = { badHours: true };
      }

      controlHours.setErrors(res);
    };
  }

  sendForm() {
    const data = {
      hours: this.form.value.hours,
      paymentMethod: this.form.value.paymentMethod,
    };
    this.dialogRef.close(data);
  }

  get totalPrice() {
    if (this.data.priceHour && this.form.value.hours) {
      return (
        Number.parseFloat(this.data.priceHour) *
        Number.parseFloat(this.form.value.hours)
      );
    }
    return false;
  }
}
